import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { graphql, Link } from "gatsby";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCoverflow, Mousewheel } from "swiper/modules";

import { motion, animate } from "framer-motion";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import Header from "../components/header";
import Form from "../components/form";
import Seo from "../components/seo";
import { IconChevronRight } from "@tabler/icons-react";
import SuggestedFlowers from "../components/suggestedFlowers";

export const variants = {
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
  hide: {
    y: 100,
    opacity: 0,
    transition: {
      type: "spring",
      duration: 0.2,
    },
  },
};

export default function ProductTemplate({ data }) {
  const [visible, setVisible] = React.useState(false);
  const { content, title, featuredImage, categories } = data.wpFlower;

  const {
    color,
    headSize,
    length,
    vaseLife,
    flowerVideo,
    firstFlowerStageImg,
    secondFlowerStageImg,
    thirdFlowerStageImg,
    topDownFlowerStageImg,
    occasion,
    suggestedFlowers,
  } = data.wpFlower.flowerExtraFields;
  console.log(suggestedFlowers);

  let mainCategory = 0;

  const flowerDetails = (
    <ul className="list-disc ml-[22px]">
      <li>
        <span className="font-bold">Color:</span>{" "}
        <span className=""> {color}</span>
      </li>

      <li>
        <span className="font-bold">Head Size:</span>{" "}
        <span className="">{headSize}cm</span>
      </li>

      <li>
        <span className="font-bold">Length:</span>{" "}
        <span className="">{length}</span>
      </li>

      <li>
        <span className="font-bold">Vase Life</span>{" "}
        <span className=""> {vaseLife} Days</span>
      </li>
    </ul>
  );

  const flowerCare = (
    <div
      className="h-full lg:overflow-y-auto flower-care"
      dangerouslySetInnerHTML={{ __html: data.wpPage.content }}
    ></div>
  );
  const flowerOccasions = (
    <div dangerouslySetInnerHTML={{ __html: occasion }}></div>
  );

  const tabs = [
    { name: "Details", content: flowerDetails },
    { name: "Flower Care", content: flowerCare },
  ];

  occasion && tabs.push({ name: "Ideal Occasions", content: flowerOccasions });
  suggestedFlowers &&
    tabs.push({
      name: "Suggested Flowers",
      content: <SuggestedFlowers flowers={suggestedFlowers} />,
    });

  const [currentInfo, setCurrentInfo] = React.useState(tabs[0]);
  const [indexInfo, setIndexInfo] = React.useState(0);

  const categoriesLabel = [
    { title: "Spray Roses", slug: "/category/spray-roses" },
    { title: "Garden Roses", slug: "/category/garden-roses" },
    { title: "Roses", slug: "/category/roses" },
  ];

  let hasColorInTitle = title.includes(color);

  categories.nodes.forEach((cat) => {
    if (cat.name === "Spray Roses") {
      mainCategory = 0;
    }
    if (cat.name === "Garden Roses") {
      mainCategory = 1;
    }
    if (cat.name === "Roses") {
      mainCategory = 2;
    }
  });

  function Toggle() {
    setVisible((prevState) => !prevState);
  }

  function imagesCheck() {
    let flowerImgs = [
      topDownFlowerStageImg,
      firstFlowerStageImg,
      secondFlowerStageImg,
      thirdFlowerStageImg,
      featuredImage,
    ];
    // let flowerImgs = [featuredImage]
    let checkedImgs = [];

    flowerImgs.forEach((img) => {
      img != null && checkedImgs.push(img);
    });

    return checkedImgs;
  }
  const checkedImages = imagesCheck();

  const swiperImages = checkedImages.map((image, index) => {
    const companySuffix = "premium Ecuadorian rose for export by Royal Flowers";
    const imagesAltSuffix = [
      "in topdown view",
      "first stage of bloom",
      "second stage of bloom",
      "third stage of bloom",
    ];

    return (
      <SwiperSlide>
        <GatsbyImage
          image={image.node.gatsbyImage}
          alt={`${title} ${mainCategory === 0 ? "Spray Rose" : "Rose"} ${
            imagesAltSuffix[index]
          }, ${companySuffix}`}
          style={{ maxHeight: "70vh", marginTop: "13vh" }}
          draggable={false} // ❌ evita arrastrar la imagen
          onContextMenu={(e) => e.preventDefault()} // Bloquea clic derecho
        />
      </SwiperSlide>
    );
  });

  function changeInfo(name) {
    var indice = tabs.findIndex((tab) => {
      return tab.name === name;
    });

    setCurrentInfo(tabs[indice]);
    setIndexInfo(indice);
    var navTab = document.getElementById("navTab");
    navTab.style.transform = `translate(0, ${indice * 40}px)`;
  }

  const imagesSlider = (
    <Swiper
      spaceBetween={8}
      loop={true}
      slidesPerView={2}
      mousewheel={{
        enabled: true,
        sensitivity: 1,
        releaseOnEdges: true,
      }}
      effect={"coverflow"}
      centeredSlides={true}
      grabCursor={true}
      coverflowEffect={{
        scale: 1,
        rotate: 2,
        stretch: 0,
        depth: 120,
        modifier: 4.5,
        slideShadows: false,
      }}
      pagination={{
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}"></span>`;
        },
      }}
      // navigation={{
      //     nextEl:'.swiper-button-next',
      //     prevEl:'.swiper-button-prev',
      //     clickable:true

      // }}

      modules={[EffectCoverflow, Pagination, Mousewheel]}
    >
      {swiperImages.length <= 3 &&
      data.wpFlower.flowerExtraFields.flowerVideo == null
        ? [...swiperImages, ...swiperImages]
        : [...swiperImages]}
      {data.wpFlower.flowerExtraFields.flowerVideo && (
        <SwiperSlide>
          <div
            style={{ maxHeight: "70vh", marginTop: "13vh" }}
            className="overflow-hidden flex justify-center items-center"
          >
            <video autoPlay muted loop playsinline className="product-video">
              <source
                src={data.wpFlower.flowerExtraFields.flowerVideo}
                type="video/webm"
              />
            </video>
          </div>
        </SwiperSlide>
      )}

      <div className="product-slider-controler" style={{ marginTop: "10%" }}>
        <div className="swiper-pagination"></div>
      </div>
    </Swiper>
  );

  return (
    <main className={`product-container relative overflow-hidden`}>
      <Header />
      <div className="pt-[50px] h-full lg:flex lg:flex-row lg:h-[100vh] lg:justify-center lg:items-center xl:items-start gap-[5rem] pb-16 md:pb-0">
        <motion.div
          animate={{
            opacity: 1,
            transform: "translateX(0%)",
            transition: { duration: 0.8, delay: 0.5, type: "spring" },
          }}
          initial={{ opacity: 0, transform: "translateX(-3%)" }}
          className="hidden lg:block xl:h-full xl:flex xl:items-center xl:justify-center container-product-slide"
          draggable={false} // ❌ evita arrastrar la imagen
          onContextMenu={(e) => e.preventDefault()} // Bloquea clic derecho
        >
          {imagesSlider}
        </motion.div>
        <motion.div
          animate={{
            opacity: 1,
            transform: "translateY(0%)",
            transition: { duration: 0.8, delay: 0.5, type: "spring" },
          }}
          initial={{ opacity: 0, transform: "translateY(3%)" }}
          className="block lg:hidden xl:hidden min-w-[0]"
        >
          {imagesSlider}
        </motion.div>

        <motion.div
          animate={{
            opacity: 1,
            transform: "translateX(0%)",
            transition: { duration: 0.8, delay: 0.3, type: "spring" },
          }}
          initial={{ opacity: 0, transform: "translateX(3%)" }}
          className="flex flex-col flex-1 gap-6 mb-14 h-full
  mt-32 overflow-hidden justify-center
  [@media(min-width:1026px)]:justify-start
  [@media(max-width:1279px)]:overflow-y-auto
  xl:mt-12 xl:overflow-y-auto"
          id="product-text"
        >
          <div className="">
            <div className="w-full flex gap-2 items-center justify-center py-4">
              <a
                className="hover:underline"
                href={categoriesLabel[mainCategory].slug}
              >
                {categoriesLabel[mainCategory].title}
              </a>
              <span>
                <IconChevronRight stroke={1} />
              </span>
              <span>
                {title} {hasColorInTitle ? "" : color}{" "}
                {mainCategory === 0 ? "Roses" : "Rose"}
              </span>
            </div>
            <h1 className="font-bold uppercase mb-4 md:mb-8 w-full text-center">
              {title} {hasColorInTitle ? "" : color}{" "}
              {mainCategory === 0 ? "Roses" : "Rose"}
            </h1>
            <p dangerouslySetInnerHTML={{ __html: content }}></p>
          </div>

          <div className="flex flex-col gap-6 ">
            <hr />

            <div className="flex left-px sm:left-0 sm:relative max-w-[100%] overflow-x-auto overflow-y-hidden pb-[3px] w-full sm:gap-8 py-4">
              <div
                id="navTab"
                className={`absolute hidden overflow-hidden sm:block sm:w-[2px] sm:h-[40px] rounded-lg transition-all ease-in-out duration-150 delay-200 translate-y-0`}
              ></div>
              {tabs.map((tab) => {
                let style;

                if (tab.name === currentInfo.name) {
                  style = "border-black font-bold border-b-2";
                } else {
                  style = "text-gray-400 border-b-0";
                }

                return (
                  <button
                    key={tabs.indexOf(tab)}
                    onClick={() => changeInfo(tab.name)}
                    onTouchEnd={() => changeInfo(tab.name)}
                    className={`flex w-[50%] uppercase sm:w-fit items-center flex-col sm:flex-row justify-center gap-2   sm:mb-0 px-3 whitespace-nowrap text-md text-left ${style}`}
                  >
                    {tab.name}
                  </button>
                );
              })}
            </div>

            <motion.div
              key={indexInfo}
              variants={variants}
              animate={"show"}
              initial="hide"
              exit="hide"
              className="flex-col basis-full sm:basis-3/4 sm:pt-0 h-full"
            >
              <div className="w-full flex flex-wrap py-8 gap-8 items-center justify-center sm:justify-start mb-6 h-full">
                {currentInfo.content && (
                  <div className="h-full w-full flex gap-6">
                    {currentInfo.content}
                  </div>
                )}
              </div>
              <hr />
            </motion.div>
          </div>

          <div className="flex justify-end ">
            {/* <button
              onClick={Toggle}
              onTouchEnd={Toggle}
              className=" px-6 py-2 text-center border uppercase hover:bg-charcoal hover:text-cream transition-all duration-200 ease-in-out"
            >
              Wholesale info request
            </button> */}
          </div>
        </motion.div>
      </div>
    </main>
  );
}

export function Head({ data }) {
  const {
    wpFlower: { title, featuredImage, flowerExtraFields, categories, seo },
  } = data;

  let mainCategory = "";
  let isColorInName = title.includes(flowerExtraFields.color);
  console.log(isColorInName);

  categories.nodes.forEach((cat) => {
    if (cat.name === "Spray Roses") {
      mainCategory = "Spray Rose";
    }
    if (cat.name === "Roses") {
      mainCategory = "Rose";
    }
  });

  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: title,
    image: [`${featuredImage?.node?.sourceUrl}`],
    description: seo.metaDesc,
    category: "Roses",
    brand: {
      "@type": "Organization",
      name: "Royal Flowers",
      url: "https://royalflowersgroup.com",
    },
    color: flowerExtraFields.color,
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Head Size",
        value: flowerExtraFields.headSize,
      },
      {
        "@type": "PropertyValue",
        name: "Length",
        value: flowerExtraFields.length,
      },
      {
        "@type": "PropertyValue",
        name: "Vase Life",
        value: flowerExtraFields.vaseLife,
      },
    ],
  };

  return (
    <Seo
      schema={schemaData}
      title={`${title} ${
        isColorInName ? "" : flowerExtraFields.color
      } ${mainCategory} – Wholesale Roses | Royal Flowers`}
      description={seo.metaDesc}
      rootUrl={data.site.siteMetadata.siteUrl}
      url={data.site.siteMetadata.siteUrl + "/flower/" + data.wpFlower.slug}
    ></Seo>
  );
}

export const query = graphql`
  query Products($slug: String) {
    site {
      siteMetadata {
        siteUrl
      }
    }

    wpPage(slug: { eq: "flower-care" }) {
      content
    }
    wpFlower(slug: { eq: $slug }) {
      content
      title
      slug
      featuredImage {
        node {
          gatsbyImage(width: 750, height: 1200, placeholder: NONE)
          sourceUrl
        }
      }
      seo {
        title
        metaDesc
        canonical
      }
      categories {
        nodes {
          name
          slug
        }
      }
      flowerExtraFields {
        color
        headSize
        length
        vaseLife
        flowerVideo
        occasion
        firstFlowerStageImg {
          node {
            gatsbyImage(width: 750, height: 1200, placeholder: NONE)
          }
        }
        secondFlowerStageImg {
          node {
            gatsbyImage(width: 750, height: 1200, placeholder: NONE)
          }
        }
        thirdFlowerStageImg {
          node {
            gatsbyImage(width: 750, height: 1200, placeholder: NONE)
          }
        }
        topDownFlowerStageImg {
          node {
            gatsbyImage(width: 750, height: 1200, placeholder: NONE)
          }
        }
        suggestedFlowers {
          nodes {
            ... on WpFlower {
              title
              slug
              featuredImage {
                node {
                  gatsbyImage(width: 750, height: 1200, placeholder: NONE)
                }
              }
            }
          }
        }
      }
    }
  }
`;
